module.exports = __webpack_public_path__ + "img/gsg-logo.b62fabc2.png";